import { Theme } from "@material-ui/core";

export const centerFlex = (theme: Theme) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "center"
});
